// Web client version — bump this each release so feedback + the "What's new" card key off it.
// Aligned with the mobile release train (mobile is on v1.3.4 / build 37).
export const APP_VERSION = "web-1.3.4";
